
import {
  defineComponent, ref, onMounted, Ref, computed,
} from 'vue';
import { useRouter } from 'vue-router';

/* eslint-disable import/no-cycle */
import { useMainStore } from '@/store/mainStore';
import UserInfo from '@/modules/settings/components/UserInfo.vue';
import AppButton from '@/components/UI/AppButton.vue';
import AppHeader from '@/components/AppHeader.vue';
import LocalStorageService from '@/services/LocalStorageService';
import LocalizationService from '@/services/LocalizationService';
import MonitoringService from '@/services/MonitoringService';
import LogoutConfirmationPopup from '@/modules/settings/components/LogoutConfirmationPopup.vue';
import UserService from '@/services/UserService';
import DeleteAccountConfirmationPopup from '@/modules/settings/components/DeleteAccountConfirmationPopup.vue';
import AuthService from '@/modules/auth/services/AuthService';
import ToFlutterService from '@/services/ToFlutterService';
import DesktopHeader from '@/components/desktop/DesktopHeader.vue';
import DriveAsideMainMenu from '@/modules/drive/components/desktop/DriveAsideMainMenu.vue';
import { REGISTRATION_STATE } from '@/types/enums';
import ProfileService from '@/modules/profile/services/ProfileService';

export default defineComponent({
  components: {
    DriveAsideMainMenu,
    DesktopHeader,
    DeleteAccountConfirmationPopup,
    UserInfo,
    AppButton,
    LogoutConfirmationPopup,
    AppHeader,
  },
  setup() {
    const router = useRouter();

    const mainStore = useMainStore();

    const showLanguageSwitcher = process.env.NODE_ENV === 'development';
    const currentLanguage = ref('');
    const confirmDialog: Ref<boolean> = ref(false);
    const confirmDelete = ref(false);
    const hideNotificationOptions = ref(true);
    const loadingSwitch = ref(false);
    const activeName = ref(false);
    const emailNotConfirmed = computed(() => REGISTRATION_STATE.CONFIRM_EMAIL === mainStore.user?.registrationState);
    const settings = ref({
      push: [{
        type: '',
        enabled: false,
      }],
      mail: [{
        type: '',
        enabled: false,
      }],
    });
    // const beforeChange = () => {
    //   loadingSwitch.value = true;
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       loadingSwitch.value = false;
    //       return resolve(true);
    //     }, 1000);
    //   });
    // };

    function changeSetting() {
      UserService.setNotificationSettings(settings.value).then((response) => {
        // console.log(response);
      });
    }
    function resendEmailConfirmation() {
      ProfileService.resendConfirmationEmail();
    }
    function setLanguage() {
      LocalStorageService.setLanguage(currentLanguage.value);
      LocalizationService.fetchAndStoreMessages();
    }

    function openConfirmPopup() {
      confirmDialog.value = true;
    }

    function deleteConfirmPopup() {
      confirmDelete.value = true;
    }

    function showOptions() {
      hideNotificationOptions.value = hideNotificationOptions.value !== true;
    }
    function showClueTooltip() {
      mainStore.$patch((state) => {
        state.user.showTutorial = true;
      });
    }

    function logWindow() {
      ToFlutterService.topColorHex('#ff0000');
    }

    onMounted(() => {
      currentLanguage.value = LocalStorageService.getLanguage();
      MonitoringService.sendPageMountedSpeed();
      UserService.getNotificationSettings().then((response) => {
        settings.value = response.results.data;
      });
    });

    return {
      mainStore,
      confirmDialog,
      confirmDelete,
      currentLanguage,
      showLanguageSwitcher,
      hideNotificationOptions,
      settings,
      loadingSwitch,
      activeName,
      // beforeChange,
      setLanguage,
      openConfirmPopup,
      deleteConfirmPopup,
      showOptions,
      changeSetting,
      showClueTooltip,
      emailNotConfirmed,
      resendEmailConfirmation,
      logout() {
        mainStore.logout().then((response) => {
          if (response.success) {
            router.push('/');
          }
        });
      },
      deleteAccount() {
        AuthService.deleteAccount().then((response) => {
          if (response.success) {
            router.push('/');
          }
        });
      },
      openSystemSettings: () => ToFlutterService.openSystemPermissions(),
    };
  },
});
